import ToolbarAfterSpacerItems from '../components/ToolbarAfterSpacerItems.vue';
import ToolbarBeforeSpacerItems from '../components/ToolbarBeforeSpacerItems.vue';

export const NxDefaultToolbarBeforeSpacerComponent = ToolbarBeforeSpacerItems;
export const NxDefaultToolbarAfterSpacerComponent = ToolbarAfterSpacerItems;

export default {
  beforeSpacerComponent: NxDefaultToolbarBeforeSpacerComponent,
  afterSpacerComponent: NxDefaultToolbarAfterSpacerComponent,
};
